import { render, staticRenderFns } from "./TextInputConfig.vue?vue&type=template&id=9c3da516&scoped=true"
import script from "./TextInputConfig.vue?vue&type=script&lang=js"
export * from "./TextInputConfig.vue?vue&type=script&lang=js"
import style0 from "./TextInputConfig.vue?vue&type=style&index=0&id=9c3da516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3da516",
  null
  
)

export default component.exports